import { render, staticRenderFns } from "./subject-grading.vue?vue&type=template&id=ff8837bc&scoped=true&"
import script from "./subject-grading.vue?vue&type=script&lang=js&"
export * from "./subject-grading.vue?vue&type=script&lang=js&"
import style0 from "./subject-grading.vue?vue&type=style&index=0&id=ff8837bc&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff8837bc",
  null
  
)

export default component.exports